export default __webpack_public_path__ + "static/media/Hefeos-IQT-Dark.4149779b.svg";